import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Breadcrumb, ProductSearchPage, RoutingService } from '@spartacus/core';
import { FacetList } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ProductListComponentService } from './product-list-component.service';

/**
 * Provides access to all the facets and active facets for the Product Listing Page.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomProductFacetService {
  routeState$ = this.routing.getRouterState().pipe(map((r) => r.state));

  searchResult$: Observable<ProductSearchPage> = this.routeState$.pipe(
    switchMap((state) =>
      this.productListComponentService.model$.pipe(
        map((page) => ({
          ...page,
          breadcrumbs: this.filterBreadcrumbs(page?.breadcrumbs ?? [], state.params),
        })),
      ),
    ),
  );

  facetList$: Observable<FacetList> = this.searchResult$.pipe(
    map(
      (result: ProductSearchPage) =>
        ({
          facets: result.facets,
          activeFacets: result.breadcrumbs,
        }) as FacetList,
    ),
  );

  constructor(
    private routing: RoutingService,
    protected productListComponentService: ProductListComponentService,
  ) {}

  /**
   * Filter breadcrumbs which are not actively selected but coming from
   * the route navigation.
   *
   * The breadcrumbs might include the active category page code, which is not actively
   * selected by the user.
   */
  protected filterBreadcrumbs(breadcrumbs: Breadcrumb[], params: Params): Breadcrumb[] {
    return breadcrumbs
      ? breadcrumbs.filter(
          (breadcrumb) =>
            !(
              breadcrumb.facetCode === 'allCategories' &&
              (breadcrumb.facetValueCode === params.categoryCode || breadcrumb.facetValueCode === params.brandCode)
            ),
        )
      : [];
  }
}
